module.exports = __webpack_public_path__ + "assets/img/list_sukikamo_white_fukidashi.0fe5d663.svg";